import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

const INITIAL_STATE = {
  menuItemId: null,
  collapseItemId: null,
};

export const PRIVATE_ACTIONS = {
  initStore:
    () =>
    ({ setState }) => {
      setState(cloneDeep(INITIAL_STATE));
    },
};

export const ACTIONS = {
  toggleMenuItem:
    (id) =>
    ({ getState, setState }) => {
      const { menuItemId: current } = getState();
      setState({ menuItemId: current !== id ? id : null });
    },
  expandMenuItem:
    (id) =>
    ({ setState }) => {
      setState({ menuItemId: id });
    },

  toggleCollapseItem:
    (id) =>
    ({ getState, setState }) => {
      const { collapseItemId: current } = getState();
      setState({ collapseItemId: current !== id ? id : null });
    },

  expandMenuState:
    ({ menuItemId, collapseItemId }) =>
    ({ setState }) => {
      setState({ menuItemId, collapseItemId });
    },

  collapseAll:
    () =>
    ({ setState }) => {
      setState({
        menuItemId: null,
        collapseItemId: null,
      });
    },
};

export const MainStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'navigation-sidebar',
});
